const BACKEND_URL = process.env.REACT_APP_BACKEND_URL;
export const API = `${BACKEND_URL}/api`;

// On Netlify (production) there is no backend — forms are submitted to Netlify Forms,
// which emails each submission to the practice inbox (configured in the Netlify dashboard).
const isNetlifyHost = () => {
  if (typeof window === "undefined") return false;
  const host = window.location.hostname || "";
  return (
    host.endsWith(".netlify.app") ||
    host.endsWith(".netlify.com") ||
    host === "njtherapyonline.com" ||
    host === "www.njtherapyonline.com"
  );
};

const shouldUseNetlifyForms = () => !BACKEND_URL || isNetlifyHost();

const encodeFormData = (data) =>
  Object.keys(data)
    .map((key) => encodeURIComponent(key) + "=" + encodeURIComponent(data[key] ?? ""))
    .join("&");

const submitNetlifyForm = async (formName, payload) => {
  const response = await fetch("/", {
    method: "POST",
    headers: { "Content-Type": "application/x-www-form-urlencoded" },
    body: encodeFormData({ "form-name": formName, ...payload }),
  });
  if (!response.ok) throw new Error(`Netlify form submission failed: ${response.status}`);
  return { ok: true };
};

// `honeypot` is the hidden "bot-field" value; Netlify drops submissions where it's filled in.
export const submitInquiry = async (payload, honeypot = "") => {
  if (shouldUseNetlifyForms()) return submitNetlifyForm("inquiry", { ...payload, "bot-field": honeypot });
  const res = await fetch(`${API}/inquiry`, {
    method: "POST",
    headers: { "Content-Type": "application/json" },
    body: JSON.stringify(payload),
  });
  if (!res.ok) throw new Error(`Inquiry failed: ${res.status}`);
  return res.json();
};
